module.exports = __webpack_public_path__ + "img/Balearski otoki.08e2726f.png";